/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UploadRequest { 
    upload_id?: string;
    content?: string;
    file_name: string;
    folder_name?: string;
}

